import {_} from 'lodash';
import {IParams as IEllipsisDropdownParams} from "../ellipsis-dropdown";
import {IDropdownButton} from "..";
import {TBaseOrObservableOrFunctionType} from "../../../index";
import {getAnyValue} from "../../../util/misc";
import split_buttonHtml from './split-button.html?raw';

export const template = split_buttonHtml;

export interface ISplitButtonParams {
    mainButton: IDropdownButton | IDropdownButton[]
    buttons?: IDropdownButton[]
    dropdownParams?: Partial<IEllipsisDropdownParams>
    containerCls?: TBaseOrObservableOrFunctionType<string>
}

export class viewModel {
    private readonly mainButton: IDropdownButton[]
    private readonly buttons: IDropdownButton[]

    constructor(private params: ISplitButtonParams) {
        this.mainButton = params.mainButton
            ? Array.isArray(params.mainButton)
                ? params.mainButton
                : [params.mainButton]
            : []

        this.mainButton?.forEach(o => {
            if (typeof o.cls !== 'string') {
                o.cls = ''
            }
            o.cls += ' btn-main'
        })

        this.buttons = params.buttons ?? []
    }

    private getDropdownParams(): IEllipsisDropdownParams {
        return _.defaults(this.params.dropdownParams ?? {}, {
            buttons: this.buttons,
            icon: 'fal fa-angle-down',
            btnClass: 'btn btn-default btn-dropdown'
        })
    }

    private getContainerCls(): string {
        return getAnyValue(this.params.containerCls ?? '')
    }

    private shouldShow() {
        const a = this.mainButton.some(btn => btn.validator?.() ?? true)
        const b = this.buttons.some(btn => btn.validator?.() ?? true)
        return a || b
    }
}

